export default "__VITE_ASSET__808abccd__"